<div class="email-form-wrapper">
  @if (!this.offerError) {
    <div class="email-form-shell">
      <div class="email-form-container">
        <h3>Email Verification</h3>
        <p class="intro-copy">Enter and confirm your email to receive your request confirmation.</p>

        <div class="form-group">
          <label>Email</label>
        <input #_email type="text" [formControl]="email" class="form-control" (blur)="updateErrorMessage()" required/>
        @if (email.invalid) {
          <mat-error>{{errorMessage}}</mat-error>
        }
        </div>

        <div class="form-spacer"></div>

        <div class="form-group">
          <label>Confirm Email</label>
        <input #_emailCheck type="text" [formControl]="emailCheck" class="form-control" (blur)="updateErrorMailCheckMessage()" required/>
        @if (emailCheck.invalid) {
          <mat-error>{{errorEmailCheckMessage}}</mat-error>
        }
        </div>

        <div class="form-spacer"></div>

        <button 
          class="button-request confirm-button" 
          #cardButton
          (click)="this.updateGuestEmail()"
          [disabled]="!this.email.valid || !this.emailCheck.valid || !this.sendEmailButtonEnabled"
          [lxResponsiveClass]="{ horizontal: 'card-action-desktop', vertical: 'card-action-handset' }">
          CONFIRM
        </button>
      </div>
    </div>
  }
  @if (this.offerError) {
    <app-offer-not-available></app-offer-not-available>
  }
</div>
